var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarMuseum8Active(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3887 8.38672H14.2635V12.876H12.3887V8.38672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83789 8.38672H10.7129V12.876H8.83789V8.38672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28711 8.38672H7.16211V12.876H5.28711V8.38672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73633 8.38672H3.61121V12.876H1.73633V8.38672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8878 6.98047V6.51172H1.11133V6.98047C1.11133 7.23938 1.32117 7.44922 1.58008 7.44922H14.4191C14.6779 7.44922 14.8878 7.23938 14.8878 6.98047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5305 13.8125H0.46875C0.209839 13.8125 0 14.0223 0 14.2812V15.5312C0 15.7902 0.209839 16 0.46875 16H15.5305C15.7894 16 15.9993 15.7902 15.9993 15.5312V14.2812C15.9993 14.0223 15.7894 13.8125 15.5305 13.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.468707 5.57324H15.5312C15.7409 5.57324 15.9251 5.43396 15.9822 5.23218C16.0392 5.0304 15.9555 4.81519 15.7769 4.70532L8.24567 0.0695801C8.09504 -0.0231934 7.90497 -0.0231934 7.75422 0.0695801L0.22298 4.70532C0.0443917 4.81531 -0.0393484 5.0304 0.0177804 5.23218C0.0749092 5.43396 0.259113 5.57324 0.468707 5.57324ZM7.68134 2.75708H8.31867C8.57758 2.75708 8.78742 2.96692 8.78742 3.22583C8.78742 3.48474 8.57758 3.69458 8.31867 3.69458H7.68134C7.42243 3.69458 7.21259 3.48474 7.21259 3.22583C7.21259 2.96692 7.42243 2.75708 7.68134 2.75708Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMuseum8Active);
export default __webpack_public_path__ + "static/media/sidebar-museum-8-active.36be14b1e202e67480ffba883e9c5c58.svg";
export { ForwardRef as ReactComponent };